module.exports = __webpack_public_path__ + "img/2025-03.0a258806.jpg";